import { action } from 'satcheljs';

export default action('ON_BULK_ACTION_STOPPED', (serverFolderId: string) => ({
    serverFolderId,
}));
